// @flow
import { isEmpty } from 'lodash';
import * as TrackingApi from 'Tracking/tracking-api';
import { GA_DEFAULT_PAYLOAD } from 'Tracking/constants';

export function track(props: *, appContext: AppContext) {
  if (isEmpty(props)) {
    return false;
  }

  TrackingApi.setDataLayer(
    {
      ...GA_DEFAULT_PAYLOAD,
      ...props,
    },
    appContext,
  );
}
